import { initialize, loadMore } from '@redux/ducks/historyEvents';

/**
 * @ngdoc controller
 * @name adjust.accountSettings.controller:AccountHistoryController
 *
 * @description
 * Account history tab
 *
 */
function AccountHistoryController(Scroll, $scope, $location, $ngRedux) {
  'ngInject';
  var vm = this;

  vm.instance = 'audit';
  vm.loading = true;
  vm.noResults = true;
  vm.overrideRelative = true;
  vm.searchTerm = vm.searchTerm || $location.search().history;

  vm.update = update;
  vm.filterHistory = filterHistory;

  $scope.$emit('account-settings:active', 'account-history');
  $scope.$watch('vm.searchTerm', _handleSearchTermChange);

  Scroll.setRemote(vm.instance, true);

  const _mapDispatchToVm = {
    initialize,
    loadMore,
  };

  vm.$onInit = () => {
    const unsubscribe = $ngRedux.connect(null, _mapDispatchToVm)(vm);
    $scope.$on('$destroy', unsubscribe);

    _load();
  };

  /**
   * @ngdoc method
   * @name _load
   * @methodOf adjust.accountSettings.controller:AccountHistoryController
   *
   * @description
   * Load account history list
   *
   * @returns {promise} A promise representing the state of the audit request
   */
  function _load() {
    vm.loading = true;
    vm.noResults = true;
    vm.changeInProgress = false;

    vm.initialize({
      limit: 30,
      term: vm.searchTerm,
      onSuccessToAngularJs: function(events) {
        vm.noResults = !events.length;
        vm.hideSearch = vm.overrideRelative && vm.noResults && !vm.searchTerm;
        vm.overrideRelative = false;
        $scope.$broadcast('audit:loaded', events);
        vm.loading = false;
      },
      onErrorToAngularJs: function() {
        vm.error = true;
        vm.loading = false;
      },
    });
  }

  /**
   * @ngdoc method
   * @name update
   * @methodOf adjust.accountSettings.controller:AccountHistoryController
   *
   * @description
   * Load more audit events while scrolling
   *
   * @returns {promise} A promise representing the state of the audit request
   */
  function update() {
    $scope.$broadcast('scroll:updating:' + vm.instance, true);

    vm.loadMore({
      term: vm.searchTerm,
      onSuccessToAngularJs: function(events) {
        if (events.length) {
          $scope.$broadcast('audit:loaded', events);
        } else {
          Scroll.setLoadedRemote(vm.instance, true);
        }

        $scope.$broadcast('scroll:updating:' + vm.instance, false);
      },
    });
  }

  /**
   * @ngdoc method
   * @name filterHistory
   * @methodOf adjust.accountSettings.controller:AccountHistoryController
   *
   * @description
   * Filter account history by search term
   *
   * @param {string=} term search term
   */
  function filterHistory(term) {
    vm.searchTerm = term ? term.toLowerCase() : '';

    $scope.$broadcast('audit:reset');
    Scroll.setLoadedRemote(vm.instance, false);

    _load();
  }

  /**
   * Track the search term change in order to do some conditioning until debounced search callback fires back
   *
   * @param {string} n new search term
   * @param {string} o old search term
   * @private
   */
  function _handleSearchTermChange(n, o) {
    if (n !== o && !angular.isUndefined(o)) {
      vm.changeInProgress = true;
    }
  }
}
export { AccountHistoryController };
